import { render, staticRenderFns } from "./mypage-layout.vue?vue&type=template&id=1889b421&"
import script from "./mypage-layout.vue?vue&type=script&lang=js&"
export * from "./mypage-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports